var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "remind-list-trend" },
    [
      _vm._m(0),
      _c("BarChart", {
        attrs: {
          height: "300px",
          fields: _vm.fields,
          dataSource: _vm.dataSource,
          color: ["#FBB040", "#5BBE7A"],
        },
      }),
      _c("div", { staticClass: "analyse-card" }, [
        _vm._m(1),
        _c("div", { staticClass: "analyse-item" }, [
          _vm._v(
            "\n      本月总提醒人数" +
              _vm._s(_vm.trendText.totalRemindCount) +
              "人，已处理" +
              _vm._s(_vm.trendText.processedCount) +
              "人，提醒人数最多的是" +
              _vm._s(_vm.trendText.maxRemindWeekDate) +
              "的这周，共提醒" +
              _vm._s(_vm.trendText.maxRemindWeekCount) +
              "人，提醒人数最少的是" +
              _vm._s(_vm.trendText.minRemindWeekDate) +
              "的这周，共提醒" +
              _vm._s(_vm.trendText.minRemindWeekCount) +
              "人，总体上相比上个月的提醒名单呈现下降趋势\n    "
          ),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticClass: "flex-align-center",
        staticStyle: { "margin-bottom": "20px" },
      },
      [
        _c("img", {
          staticStyle: {
            width: "24px",
            height: "24px",
            "margin-right": "15px",
          },
          attrs: {
            src: require("@/assets/imgs/school/monthRecord/rank.png"),
            alt: "",
          },
        }),
        _c("div", { staticClass: "record-title" }, [
          _vm._v("全校提醒名单人数变化趋势"),
        ]),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticClass: "flex-align-center",
        staticStyle: { "margin-bottom": "10px" },
      },
      [
        _c("img", {
          staticStyle: { width: "14px", height: "14px", "margin-right": "5px" },
          attrs: {
            src: require("@/assets/imgs/school/monthRecord/analyse.png"),
            alt: "",
          },
        }),
        _c("span", [_vm._v("趋势分析：")]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }